"use strict";

var __makeTemplateObject = this && this.__makeTemplateObject || function (cooked, raw) {
  if (Object.defineProperty) {
    Object.defineProperty(cooked, "raw", {
      value: raw
    });
  } else {
    cooked.raw = raw;
  }

  return cooked;
};

var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];

      for (var p in s) {
        if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
      }
    }

    return t;
  };

  return __assign.apply(this, arguments);
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var React = require("react");

var styled_components_1 = require("styled-components");

var ballFirst = function ballFirst(amount) {
  return styled_components_1.keyframes(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n    33% {\n      transform: translate(", "px, ", "px);\n    }\n    66% {\n      transform: translate(", "px, 0);\n    }\n    100% {\n      transform: translate(0px, 0px);\n    }\n"], ["\n    33% {\n      transform: translate(", "px, ", "px);\n    }\n    66% {\n      transform: translate(", "px, 0);\n    }\n    100% {\n      transform: translate(0px, 0px);\n    }\n"])), amount / 2, -amount, amount);
};

var ballSecond = function ballSecond(amount) {
  return styled_components_1.keyframes(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  33% {\n    transform: translate(", "px, ", "px);\n  }\n  66% {\n    transform: translate(", "px, ", "px);\n  }\n  100% {\n    transform: translate(0, 0);\n  }\n"], ["\n  33% {\n    transform: translate(", "px, ", "px);\n  }\n  66% {\n    transform: translate(", "px, ", "px);\n  }\n  100% {\n    transform: translate(0, 0);\n  }\n"])), amount / 2, amount, -amount / 2, amount);
};

var ballThird = function ballThird(amount) {
  return styled_components_1.keyframes(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n  33% {\n    transform: translate(", "px, 0);\n  }\n  66% {\n    transform: translate(", "px, -", "px);\n  }\n  100% {\n    transform: translate(0, 0);\n  }\n"], ["\n  33% {\n    transform: translate(", "px, 0);\n  }\n  66% {\n    transform: translate(", "px, -", "px);\n  }\n  100% {\n    transform: translate(0, 0);\n  }\n"])), -amount, -amount / 2, amount);
};

var Ball = styled_components_1.default.div(templateObject_5 || (templateObject_5 = __makeTemplateObject(["\n  ", "\n"], ["\n  ", "\n"])), function (p) {
  return styled_components_1.css(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n    position: absolute;\n    width: ", "px;\n    height: ", "px;\n    border-radius: 100%;\n    ", "\n    border: ", "px solid ", ";\n    animation-fill-mode: both;\n  "], ["\n    position: absolute;\n    width: ", "px;\n    height: ", "px;\n    border-radius: 100%;\n    ", "\n    border: ", "px solid ", ";\n    animation-fill-mode: both;\n  "])), p.ballSize, p.ballSize, p.alternate && "\n      background: " + p.color + ";\n    ", p.ballBorderSize, p.color);
});
var FirstBall = styled_components_1.default(Ball)(templateObject_7 || (templateObject_7 = __makeTemplateObject(["\n  ", "\n"], ["\n  ", "\n"])), function (p) {
  return styled_components_1.css(templateObject_6 || (templateObject_6 = __makeTemplateObject(["\n    animation: ", " 2s ease-in-out infinite;\n    top: ", "px;\n  "], ["\n    animation: ", " 2s ease-in-out infinite;\n    top: ", "px;\n  "])), ballFirst(p.amount), p.amount);
});
var SecondBall = styled_components_1.default(Ball)(templateObject_9 || (templateObject_9 = __makeTemplateObject(["\n  ", "\n"], ["\n  ", "\n"])), function (p) {
  return styled_components_1.css(templateObject_8 || (templateObject_8 = __makeTemplateObject(["\n    animation: ", " 2s ease-in-out infinite;\n    left: ", "px;\n  "], ["\n    animation: ", " 2s ease-in-out infinite;\n    left: ", "px;\n  "])), ballSecond(p.amount), p.amount / 2);
});
var ThirdBall = styled_components_1.default(Ball)(templateObject_11 || (templateObject_11 = __makeTemplateObject(["\n  ", "\n"], ["\n  ", "\n"])), function (p) {
  return styled_components_1.css(templateObject_10 || (templateObject_10 = __makeTemplateObject(["\n    animation: ", " 2s ease-in-out infinite;\n    top: ", "px;\n    left: ", "px;\n  "], ["\n    animation: ", " 2s ease-in-out infinite;\n    top: ", "px;\n    left: ", "px;\n  "])), ballThird(p.amount), p.amount, p.amount);
});

function Balls(_a) {
  var color = _a.color,
      alternate = _a.alternate,
      themeStyles = _a.themeStyles,
      height = _a.height,
      width = _a.width;
  var ballColor = color;

  var ballStyles = __assign(__assign({}, themeStyles), {
    color: ballColor,
    alternate: alternate
  });

  return React.createElement("div", {
    style: {
      position: 'relative',
      height: height,
      width: width
    }
  }, [FirstBall, SecondBall, ThirdBall].map(function (loadingBall, key) {
    return React.createElement(loadingBall, __assign({
      key: key
    }, ballStyles));
  }));
}

exports.default = Balls;
var templateObject_1, templateObject_2, templateObject_3, templateObject_4, templateObject_5, templateObject_6, templateObject_7, templateObject_8, templateObject_9, templateObject_10, templateObject_11;